import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'journeyStepFilter', standalone: true })
@Injectable({providedIn: 'root'})
export class JourneyStepFilterPipe implements PipeTransform {
	
	transform(serviceObjects, expected) {
		var filteredList: Array<any> = [];
		for (var index in serviceObjects) {
			if (serviceObjects[index].step === expected) {
				filteredList.push(serviceObjects[index]);
			}
		}
		return this.sort(filteredList);
	}
	
	sort(filteredList) {
		filteredList.sort(function(a, b) {
			if (a.displayOrder && !b.displayOrder) {
				return true;
			} else if (!a.displayOrder && b.displayOrder) {
				return false;
			} else {
				return a.displayOrder - b.displayOrder;
			}
		});
		return filteredList;
	}
	
}